module.exports = __webpack_public_path__ + "static/festival5.7e95c42b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/festival5.jpg
// module id = 619
// module chunks = 262155479546674